import { PrivateAPINamespace } from './PrivateAPINamespace';

export class BreakpointsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'breakpoints';

  get() {
    return this.ps.hostAPI.breakpoints?.get({ id: '213', type: 'DESKTOP' });
  }
}
